import type { QuizAnswers } from "@/src/components/OnboardingWizard/types";
import type {
  OnboardingV3Answers,
  OnboardingV3GenerateRequestBody,
  OnboardingV3GoalType,
  OnboardingV3RiskProfile,
} from "./onboardingV3Types";
import { mapGoalIdToGoalType } from "./mapGoalIdToGoalType";

const AGE_RANGE_MIDPOINT: Record<string, number> = {
  "18-24": 21,
  "25-34": 30,
  "35-44": 40,
  "45-54": 50,
  "55+": 58,
};

const RISK_TO_PROFILE: Record<string, OnboardingV3RiskProfile> = {
  safe: "safe",
  balanced: "balanced",
  growth: "growth",
};

export const mapAgeRangeToMidpoint = (ageRange: string): number =>
  AGE_RANGE_MIDPOINT[ageRange] ?? 30;

export const mapQuizAnswersToV3Answers = (
  answers: QuizAnswers,
): OnboardingV3Answers => ({
  name: answers.name.trim(),
  age: mapAgeRangeToMidpoint(answers.age),
  annualIncome: answers.income,
  monthlyExpense: answers.expenses,
  cash: answers.cash,
  debt: answers.debt,
  invested: answers.invest,
  riskProfile: RISK_TO_PROFILE[answers.risk] ?? "balanced",
});

export const mapQuizAnswersToV3Request = (
  answers: QuizAnswers,
  goalType?: OnboardingV3GoalType,
): OnboardingV3GenerateRequestBody => ({
  goalType: goalType ?? mapGoalIdToGoalType(answers.goalId),
  answers: mapQuizAnswersToV3Answers(answers),
});
